import { BaseDto } from '@/shared/dtos/base-dto';

export class qrs extends BaseDto {
    public code !: string;
    public prize_text !: string;
    public has_prize !: boolean;
    public redeemed !: boolean;
    public redeemed_at!:Date;

 } 
